/**
 * downloadReport — generates and downloads a CSV/text report from structured data.
 * Used across all dashboards (Police, Fire, Hospital, Ambulance, Admin).
 */
export function downloadReport({ filename = "report", headers = [], rows = [], title = "" }) {
  const now = new Date().toLocaleString();
  const separator = ",";

  let csv = "";

  // Title section
  if (title) {
    csv += `"${title}"\n`;
    csv += `"Generated: ${now}"\n`;
    csv += `"Powered by Reyansh Technologies"\n`;
    csv += "\n";
  }

  // Header row
  if (headers.length > 0) {
    csv += headers.map((h) => `"${h}"`).join(separator) + "\n";
  }

  // Data rows
  rows.forEach((row) => {
    const line = row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(separator);
    csv += line + "\n";
  });

  // Download
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
